import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-wf-end",
  "use": "icon-wf-end-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-wf-end\">\n<path d=\"M101.3,200.6C46,200.6,1,155.6,1,100.3S46,0,101.3,0s100.3,45,100.3,100.3S156.6,200.6,101.3,200.6L101.3,200.6z\n\t M101.3,15.1c-47,0-85.2,38.2-85.2,85.2s38.2,85.2,85.2,85.2s85.2-38.2,85.2-85.2S148.3,15.1,101.3,15.1L101.3,15.1z\" />\n<path d=\"M70.2,69.1h62.3v62.3H70.2V69.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol